<template>
  <div class="container">
    <section id="editContent" class="columnContainer">
      <div class="innerColumn">
        <h1 class="contentTitle">{{locale.product}}</h1>
        <ProductList
          :locale="locale"
          :list="list"
          :init="setInit"
          @checked="onChecked" />
        <Pagination
          :option="pagingOption"
          @onPagingClick="onPagingClick" />
      </div>
      <div class="innerSide"><div class="sideBox">
      </div></div>
    </section>
    <div id="setContent">
      <SetProduct
        :locale="locale"
        :checked="checkedList"
        :list="productList"
        @uncheckedAll="onUncheckedAll" />
    </div>
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ProductList from '@/components/Product/List'
import SetProduct from '@/components/Product/SettingList'
import Pagination from '@/components/Pagination/Pagination'

export default {
  name: 'Product',
  components: {
    ProductList,
    SetProduct,
    Pagination
  },
  props: [
    'locale',
    'paging'
  ],
  computed: {
    ...mapGetters({
      productList: 'product/list'
    }),
    list () {
      const sort = this.sortBy
      const list = this.productList.map(x => x).sort(function (a, b) {
        return a[sort] > b[sort] ? -1 : a[sort] < b[sort] ? 1 : 0
      })
      const itemCount = this.pagingData.itemCount
      const start = (this.paging - 1) * itemCount
      return list.slice(start, start + itemCount)
    },
    pagingOption () {
      return {
        limit: parseInt(this.productList.length / this.pagingData.itemCount) + 1,
        force: Number(this.paging)
      }
    }
  },
  created () {
    this.showTemplates = false
    this.$store.commit('onLoading', true)
    this.$store.dispatch('product/setProductListData').then(() => {
      setTimeout(() => {
        this.$store.commit('onLoading', false)
      }, 1000)
    })
  },
  mounted () {
  },
  data () {
    return {
      setInit: false,
      checkedList: [],
      sortBy: 'updated',
      pagingData: {
        itemCount: 10 // 페이지당 노출할 리스트 아이템
      }
    }
  },
  methods: {
    onChecked (ids) {
      this.checkedList = ids
      this.setInit = false
    },
    onPagingClick (current) {
      this.$router.replace({ name: 'productList', params: { paging: current } })
    },
    onUncheckedAll () {
      this.setInit = true
    }
  }
}
</script>
